export default {
  dismissLabel: {
    id: 'modalOptions.dismiss.defaultLabel',
    defaultMessage: 'Cancel',
  },
};
